import React from "react";
import PropTypes from "prop-types";

/**
 * Shared manage list table shell — white card, scroll area, optional footer.
 */
function ManageDataTable({ children, footer }) {
  return (
    <div className="manage-data-table">
      <div className="manage-data-table-scroll">
        {children}
      </div>
      {footer ? (
        <div className="manage-data-table-footer">{footer}</div>
      ) : null}
    </div>
  );
}

ManageDataTable.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node
};

export default ManageDataTable;
